module.exports = __webpack_public_path__ + "img/27.1d4b352c.png";